// Typelizer digest 2702c9d139b43ec4a2c2b3aab0052127
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/purchase_orders/:purchase_order_id/approval */
  create: (
    params: { purchaseOrderId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/purchase_orders/:purchase_order_id/approval', params, options),
    method: 'post',
  }),
}
